/**
 * @module experience/order-payment
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

import {
  Payment,
  PaymentCard,
  CardHolderAddress,
} from '@support/api/proxies/requests/api-2614.interface';
import { OrderPaymentModel } from '@experience/shop/order-payment/online-order-payment/models/online-order-payment.model';
import { CardAddressModel } from '@experience/shop/order-payment/online-order-payment/credit-card-address/models/credit-card-address.model';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { PaymentInformation } from '@support/payment/online-payment/models/card-entry-form.model';

export class PostValidationModel {
  /**
   * To store payment
   */
  public payment: Payment;
  /**
   * To check termsAgreementIndicator
   */
  public termsAgreementIndicator: boolean;
  /**
   * To check TermsAndCondition
   */
  public termsAgreementTime: string;
  /**
   * To store customerType
   */
  public productGroup: string;
  /**
   * To store customerType
   */
  public programCode: string;
  /**
   * To store customerType
   */
  public orderTypes: string;
  /**
   * To store billerCode
   */
  public billerCode: string;
  /**
   * get account id
   */
  public accountId: string;
  /**
   * To check isStoreDigital
   */
  public isStoreDigital: boolean;

  constructor(
    paymentDetails?: OrderPaymentModel,
    stateStoreUtilsService?: StateStoreUtilsService,
    accountId?: string,
    orderType?: string,
    productGroup?: string
  ) {
    this.programCode = 'U1POSTLEGACY';
    this.termsAgreementIndicator = true;
    this.termsAgreementTime = Date.now().toString();
    this.productGroup = productGroup || 'HardGoods';
    this.programCode = 'U2POSTCNP';
    this.orderTypes = orderType;
    this.billerCode = 'ERICSSON';
    this.payment = <Payment>{};
    if (paymentDetails) {
      this.setPayment(paymentDetails.cardDetails);
      this.setAddress(paymentDetails.cardAddressDetails);
    }
    if (stateStoreUtilsService) {
      this.isStoreDigital = this.checkStoreDigital(stateStoreUtilsService);
    }
    if (accountId !== 'ANON') {
      this.accountId = accountId;
    }
  }

  /**
   * Function to set payment
   * @returns Payment
   */
  public setPayment(cardDetails: PaymentInformation): void {
    const two = 2;
    const four = 4;
    this.payment.paymentCard = <PaymentCard>{};
    this.payment.paymentMethodCode = cardDetails.paymentMethodCode;
    this.payment.paymentCard.cardHolderName = cardDetails.fullName;
    this.payment.paymentCard.cardNumber = cardDetails.encryptedCardNumber;
    this.payment.paymentCard.cvv = cardDetails.cvv;
    this.payment.paymentCard.typeCode = cardDetails.cardType.toUpperCase();
    this.payment.storePaymentMethodIndicator = true;
    this.payment.isTokenRequired = true;
    this.payment.paymentCard.expirationMonthYear = cardDetails.expirationMonth
      .toString()
      .concat(cardDetails.expirationYear.toString().substring(two, four));
  }

  /**
   * Function to set CardHolder Address
   * @param {CardAddressModel} cardAddressDetails
   */
  public setAddress(cardAddressDetails: CardAddressModel): void {
    this.payment.paymentCard.cardHolderAddress = <CardHolderAddress>{};
    this.payment.paymentCard.cardHolderAddress.purposes = 'BillTo';
    this.payment.paymentCard.cardHolderAddress.addressLine1 = cardAddressDetails.address1.value;
    this.payment.paymentCard.cardHolderAddress.addressLine2 = cardAddressDetails.address2.value;
    this.payment.paymentCard.cardHolderAddress.cityName = cardAddressDetails.city.value;
    this.payment.paymentCard.cardHolderAddress.stateCode = cardAddressDetails.state.value;
    this.payment.paymentCard.cardHolderAddress.zip = cardAddressDetails.zipCode.value;
  }
  /**
   * Function to check store is digital or not
   * @returns boolean
   */
  public checkStoreDigital(stateStoreUtilsService: StateStoreUtilsService): boolean {
    const isDigital = stateStoreUtilsService.getStoreData();
    return isDigital.isStoreDigital;
  }
}
